import {AppIdentifier, appIdentifierToActionPrefixMap} from "../../types";
import {ACTION_APP_LOADED, ACTION_SET_JWT, ACTION_SET_MODAL_STATE} from "./constants";

export interface ICryptoAccountLinkPayoutsState {
  jwt: string;
  isAppLoaded: boolean;
  isAppActive: boolean;
}

export interface ICryptoAccountLinkPayoutsAction {
  type: string;
  jwt?: string;
  isAppActive?: boolean;
  isAppLoaded?: boolean;
}

const INITIAL_STATE: ICryptoAccountLinkPayoutsState = {
  jwt: "",
  isAppActive: false,
  isAppLoaded: false
}

const applySetIsAppActive = (state: ICryptoAccountLinkPayoutsState, action: ICryptoAccountLinkPayoutsAction): ICryptoAccountLinkPayoutsState => {
  return {
    ...state,
    isAppActive: !!action.isAppActive,
  }
}

const applySetSendJWTToApp = (state: ICryptoAccountLinkPayoutsState, action: ICryptoAccountLinkPayoutsAction): ICryptoAccountLinkPayoutsState => {
  return {
    ...state,
    isAppLoaded: !!action.isAppLoaded,
  }
}

const applySetJWT = (state: ICryptoAccountLinkPayoutsState, action: ICryptoAccountLinkPayoutsAction): ICryptoAccountLinkPayoutsState => {
  return {
    ...state,
    jwt: action.jwt as string,
  }
}

const reducerMap: {
  [actionType: string]: (state: ICryptoAccountLinkPayoutsState, action: ICryptoAccountLinkPayoutsAction) => ICryptoAccountLinkPayoutsState
} = {
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.CRYPTO_ACCOUNT_LINK_PAYOUTS)}${ACTION_SET_JWT}`]: applySetJWT,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.CRYPTO_ACCOUNT_LINK_PAYOUTS)}${ACTION_SET_MODAL_STATE}`]: applySetIsAppActive,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.CRYPTO_ACCOUNT_LINK_PAYOUTS)}${ACTION_APP_LOADED}`]: applySetSendJWTToApp,
};

const cryptoAccountLinkPayoutsReducer = (state = INITIAL_STATE, action: ICryptoAccountLinkPayoutsAction) => {
  if (!!action.type && !!reducerMap[action.type]) {
    return reducerMap[action.type](state, action);
  } else {
    return state;
  }
}

export default cryptoAccountLinkPayoutsReducer;
